var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "content"
  }, [_c('div', [_c('div', {
    staticClass: "new-modal-error-icon"
  }, [_vm._v("!")]), _c('h3', {
    staticClass: "new-modal-generic-error-title"
  }, [_vm._v(_vm._s(_vm.translations.seekGenericErrorTitle))]), _c('p', {
    staticClass: "new-modal-description"
  }, [_vm._v("\n      " + _vm._s(_vm.translations.seekGenericErrorDescription) + "\n    ")])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }